import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import { ReactComponent as ArrowLeft } from "../../../../assets/elevva-pro-icons/table-arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/elevva-pro-icons/table-arrow-right.svg";

import moment from "moment";
import { useEffect, useState } from "react";
import { instanceMob, laptopMax1350 } from "../../../../utils/utils";
import { formatMoney } from "./graphics/simple-bar-chart.tsx";
import ConfirmDeletionModal from "../modal-delete.js";
import { Modal } from "bootstrap";

const TableCustomAdministrative = (props) => {
  const users = props.users;
  const page = props.page;
  const count = props.count;
  const changePage = props.changePage;

  const [modal, setModal] = useState(null);

  const handleDetailClick = (customerId) => {
    instanceMob
      .get(`/admin/metrics/customer/${customerId}`)
      .then((res) => {
        if (res.status) {
          const data = res.data;
          console.log("Detalle del cliente:", data);

          setModal(
            <DetailModal
              key={`modal-${data.id}-${Date.now()}`}
              data={data}
              onClose={() => setModal(null)}
            />
          );
        }
      })
      .catch((err) => {
        let msg_error = err?.response?.data;
        if (msg_error) {
          setModal(
            <ConfirmDeletionModal
              onCancel={() => setModal(null)}
              onConfirm={() => setModal(null)}
              loader={false}
            >
              Algo sucedió, intenta de nuevo
            </ConfirmDeletionModal>
          );
        }
      });
  };

  return (
    <>
      <div className={laptopMax1350.matches ? "px-0 py-2" : "py-3"}>
        <div style={{ width: "100%" }}>
          <div style={{ overflowX: "auto" }}>
            <PerfectScrollbar
              className="px-4"
              style={{
                maxHeight: "calc(75vh - 21rem)",
                overflowY: "scroll",
                minWidth: "500px",
              }}
            >
              <table style={{ width: "100%", backgroundColor: "white" }}>
                <thead
                  className="size-table-users"
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                    borderBottom: "1px solid #A8C2D7",
                  }}
                >
                  <tr>
                    <th style={{ fontWeight: "normal", width: "30%" }}>
                      <div className="d-flex gap-2 align-items-center">
                        <span className="size-table-users">Acción</span>
                      </div>
                    </th>
                    <th style={{ fontWeight: "normal", width: "30%" }}>
                      Plan / Servicio
                    </th>
                    <th
                      className="text-center"
                      style={{ fontWeight: "normal", width: "10%" }}
                    >
                      Costo
                    </th>
                    <th
                      className="text-center"
                      style={{ fontWeight: "normal", width: "10%" }}
                    >
                      Detalle
                    </th>
                    <th
                      className="text-center"
                      style={{ fontWeight: "normal", width: "20%" }}
                    >
                      Fecha
                    </th>
                  </tr>
                </thead>
                <tbody className="w-100">
                  {users.length > 0 &&
                    users
                      .filter((e) => e.customer)
                      .map((user) => (
                        <tr
                          key={user.id}
                          className="size-table-users"
                          style={{
                            borderBottom: "1px solid #A8C2D7",
                            color: "#394F65",
                          }}
                        >
                          <td className="py-3">
                            <div className="d-flex gap-2 align-items-center">
                              <div
                                className="size-table-users"
                                style={{ textTransform: "capitalize" }}
                              >
                                {user?.log_type_name || "----"}
                              </div>
                            </div>
                          </td>
                          <td>
                            {user?.plan_name || user?.booking_service ? (
                              <>
                                {user?.plan_name || ""}{" "}
                                {user?.booking_service || ""}
                              </>
                            ) : (
                              "----"
                            )}
                          </td>
                          <td className="text-center">
                            {formatMoney.format(user.plan_price)}
                          </td>
                          <td className="text-center">
                            <svg
                              className="cursor-pointer"
                              onClick={() => handleDetailClick(user.id)}
                              width="21"
                              height="21"
                              viewBox="0 0 21 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="10.2747"
                                cy="10.2747"
                                r="10.2747"
                                fill="#B5C1CD"
                              />
                              <path
                                d="M11.1421 12.6004C10.7882 12.7965 10.4274 12.9479 10.0432 13.0362C8.66103 13.3529 7.39992 13.089 6.28371 12.2125C5.4435 11.5519 4.90694 10.6844 4.72609 9.63291C4.43996 7.96885 4.94533 6.56577 6.22993 5.46104C6.84169 4.9354 7.56007 4.61314 8.35872 4.51328C10.0076 4.30698 11.3719 4.85044 12.4234 6.14146C12.8916 6.71641 13.1728 7.3834 13.2884 8.11509C13.4423 9.08848 13.2884 10.0145 12.8196 10.8849C12.789 10.9417 12.7929 10.973 12.8385 11.0189C13.6497 11.8268 14.4569 12.638 15.2697 13.4452C15.5146 13.6874 15.6616 13.9693 15.6652 14.3167C15.6701 14.7774 15.3853 15.2105 14.9682 15.388C14.5205 15.5787 14.0315 15.4884 13.6805 15.1407C13.1934 14.6585 12.7106 14.1722 12.2262 13.6874C11.866 13.327 11.5062 12.9657 11.1421 12.6004ZM8.98891 12.0064C10.7709 11.9957 12.1753 10.5782 12.1834 8.83066C12.1917 7.0521 10.7659 5.64439 9.02968 5.62656C7.26155 5.60825 5.82106 7.02012 5.80641 8.78623C5.79176 10.5577 7.20436 11.9898 8.98891 12.0064Z"
                                fill="white"
                              />
                              <path
                                d="M8.93996 6.48691C9.3102 6.47201 9.54292 6.74789 9.5724 7.0184C9.60555 7.32162 9.36617 7.62143 9.06099 7.65097C8.92317 7.66391 8.78133 7.67099 8.65022 7.71029C8.1686 7.85531 7.85829 8.27377 7.83693 8.78598C7.82491 9.07602 7.67671 9.28866 7.4327 9.36728C7.05525 9.48886 6.67336 9.20761 6.67189 8.80746C6.66811 7.84067 7.29762 6.94955 8.21468 6.62875C8.33223 6.58749 8.45387 6.55526 8.57619 6.53183C8.69582 6.50839 8.81862 6.50107 8.93996 6.48691Z"
                                fill="white"
                              />
                            </svg>
                          </td>
                          <td className="text-center">
                            {moment(user?.log_date).format("DD-MMM-YY") ||
                              "----"}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </PerfectScrollbar>
          </div>

          <div className="d-flex justify-content-end align-items-center gap-3 mt-3 me-4">
            <span className="size-table-users">
              {Math.min((page - 1) * 10 + 1, count)} -{" "}
              {Math.min(page * 10, count)} de {count}
            </span>
            <div
              onClick={page > 1 ? () => changePage("previous") : undefined}
              className={`cursor-pointer  ${
                page > 1 ? "text-black" : "text-gray-400 cursor-not-allowed"
              }`}
            >
              <ArrowLeft width={6} />
            </div>
            <div
              onClick={page * 10 < count ? () => changePage("next") : undefined}
              className={`cursor-pointer ${
                page * 10 < count
                  ? "text-black"
                  : "text-gray-400 cursor-not-allowed"
              }`}
            >
              <ArrowRight width={6} />
            </div>
          </div>
        </div>
      </div>
      {modal}
    </>
  );
};

export default TableCustomAdministrative;

export const DetailModal = ({ data, onClose }) => {
  useEffect(() => {
    const modalElement = document.getElementById("detailModalBootstrap");
    const bootstrapModal = new Modal(modalElement);
    bootstrapModal.show();

    return () => {
      bootstrapModal.hide();
      modalElement.remove();
    };
  }, []);

  moment.locale("es");

  let formattedDate = moment(data.log_date).format("D [de] MMM [de] YYYY");
  formattedDate = formattedDate.replace(/ de (\w{3})/, (match, p1) => ` de ${p1.charAt(0).toUpperCase()}${p1.slice(1).toLowerCase()}`);

  const detailMessage = data.log_description?.trim()
      ? data.log_description
      : data.booking_service
          ? `El usuario ${data.customer_name} reservó clase de ${data.booking_service} el día ${formattedDate}.`
          : `El usuario ${data.customer_name} fue ${data.log_type_name} el día ${formattedDate}.`;

  return (
      <div
          className="modal fade"
          id="detailModalBootstrap"
          tabIndex="-1"
          aria-labelledby="detailModalLabel"
          aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm justify-content-center">
          <div
              className="modal-content rounded-4 shadow   "
              style={{ maxWidth: "350px" }}
          >
            <div className="modal-header border-1 d-flex flex-column align-items-center justify-content-center">
              <h5
                  className="modal-title fst-normal fw-medium fs-5 lh-1 text-center text-custom font-work-sans d-flex flex-column"
                  id="detailModalLabel"
                  style={{ color: "#394F65" }}
              >
                Detalle de
                <span className="fw-bold" style={{ textTransform: "capitalize" }}>
                {data.log_type_name}
              </span>
              </h5>
              <small className="small">
                Fecha de la acción: {formattedDate}
              </small>
            </div>

            <div className="modal-body p-4">
              <div className="bg-white border border-secondary-subtle rounded-4 p-3">
                <p
                    className="fw-bold mb-2 small lh-sm"
                    style={{ color: "#394F65" }}
                >
                  Detalle
                </p>
                <p
                    className="fw-medium text-secondary-emphasis small lh-sm"
                    style={{ color: "#394F65" }}
                >
                  {detailMessage}
                </p>
              </div>
            </div>

            <div className="modal-footer border-1 justify-content-center">
              <button
                  type="button"
                  className="btn btn-outline-secondary rounded-pill px-4"
                  onClick={onClose}
                  style={{
                    backgroundColor: "white",
                    borderColor: "#DFDFDF",
                    color: "#394F65",
                  }}
              >
              <span className="fw-medium text-center d-inline-block small lh-sm">
                Cerrar
              </span>
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};
